import { render, staticRenderFns } from "./workbenchDetail.vue?vue&type=template&id=6bda3334&"
import script from "./workbenchDetail.vue?vue&type=script&lang=js&"
export * from "./workbenchDetail.vue?vue&type=script&lang=js&"
import style0 from "./workbenchDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports